import { render } from "./PlayerInfo.vue?vue&type=template&id=2434e1d0&ts=true"
import script from "./PlayerInfo.vue?vue&type=script&lang=ts"
export * from "./PlayerInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__